import { render, staticRenderFns } from "./ContactanoWien.vue?vue&type=template&id=38629128&scoped=true"
import script from "./ContactanoWien.vue?vue&type=script&lang=js"
export * from "./ContactanoWien.vue?vue&type=script&lang=js"
import style0 from "./ContactanoWien.vue?vue&type=style&index=0&id=38629128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38629128",
  null
  
)

export default component.exports